import styled from 'styled-components'

export const Card = styled.div`
  padding: 24px;
  margin-top: 40px;
  height: 100%;

  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 14px 30px rgba(0, 0, 0, 0.04);
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

export const HeaderLeft = styled.div`
  min-width: 0;
`

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
`

export const MetaLine = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: gray;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MetaItem = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Separator = styled.span`
  width: 1px;
  height: 12px;
  background: rgba(17, 24, 39, 0.14);
`

export const Amount = styled.div`
  margin-top: 60px;
  font-size: 44px;
  font-weight: 600;
  line-height: 1.05;
`

export const AmountDescription = styled.span`
  font-size: 14px;
  color: gray;
`
